// extracted by mini-css-extract-plugin
export default {"container":"DevWidget__container___DV1t5","hint":"DevWidget__hint___fuEmw","handle":"DevWidget__handle___HEdKD"};